import { createSlice } from '@reduxjs/toolkit';

export const ProductVarientSlice = createSlice({
    name: 'ProductVarient',
    initialState: {
        product: {},
        productVarient: [{
            id: 1,
            mrp: "",
            units: "",
            sellingPrice: "",
            premiumPrice: "",
            date: "",
            stock: "",
            flavor: [""],
        }]
    },
    reducers: {
        setProductVarient: (state, action) => {
            state.productVarient = action?.payload;
        },
        setProductData: (state, action) => {
            return {
                ...state,
                product: { ...action.payload },
            };
        },
    },
})

export const { setProductVarient, setProductData } = ProductVarientSlice.actions;
export default ProductVarientSlice.reducer;